import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { UsuarioAppRoutingModule } from "./usuario.app-routing.module"; 

@NgModule({
    imports: [
        CommonModule,     
        UsuarioAppRoutingModule   
    ]
})
export class UsuarioAppModule { }
